<script lang="ts">
export interface PaginationProps extends PaginationRootProps, ClassProps {
	hideNumbers?: boolean;
}

export type PagintationEmits = PaginationRootEmits;
</script>
<script setup lang="ts">
import {
	mdiChevronDoubleLeft,
	mdiChevronDoubleRight,
	mdiChevronLeft,
	mdiChevronRight,
} from "@mdi/js";
import {
	PaginationEllipsis,
	PaginationFirst,
	PaginationLast,
	PaginationList,
	PaginationListItem,
	PaginationNext,
	PaginationPrev,
	PaginationRoot,
	useForwardPropsEmits,
	type PaginationRootEmits,
	type PaginationRootProps,
} from "reka-ui";
import { useDelegatedProps, type ClassProps } from "../../lib/base-props";
import { cn } from "../../lib/utils";
import Button from "../button/Button.vue";
import Icon from "../icon/Icon.vue";

const props = defineProps<PaginationProps>();
const emit = defineEmits<PagintationEmits>();

const delegatedProps = useDelegatedProps(props);

const forwarded = useForwardPropsEmits(delegatedProps, emit);
</script>

<template>
	<PaginationRoot v-slot="{ page: currentPage }" v-bind="forwarded">
		<PaginationList
			v-slot="{ items }"
			:class="cn('text-base-content flex items-center gap-1', props.class)"
		>
			<PaginationFirst asChild>
				<Button variant="ghost" size="sm">
					<Icon :d="mdiChevronDoubleLeft" />
				</Button>
			</PaginationFirst>
			<PaginationPrev asChild>
				<Button variant="ghost" size="sm">
					<Icon :d="mdiChevronLeft" />
				</Button>
			</PaginationPrev>

			<template v-if="!props.hideNumbers">
				<template v-for="(page, index) in items" :key="index">
					<PaginationListItem v-if="page.type === 'page'" :value="page.value" asChild>
						<Button
							:class="{
								'btn-active': page.value === currentPage,
							}"
							color="neutral"
							size="sm"
							variant="soft"
						>
							{{ page.value }}
						</Button>
					</PaginationListItem>
					<PaginationEllipsis v-else class="flex-center size-8" :index="index">
						&#8230;
					</PaginationEllipsis>
				</template>
			</template>

			<PaginationNext asChild>
				<Button variant="ghost" size="sm">
					<Icon :d="mdiChevronRight" />
				</Button>
			</PaginationNext>

			<PaginationLast asChild>
				<Button variant="ghost" size="sm">
					<Icon :d="mdiChevronDoubleRight" />
				</Button>
			</PaginationLast>
		</PaginationList>
	</PaginationRoot>
</template>
